import React from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    // width: '100%'
  }
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];

function getStyles(text, dropDownList, theme) {
  return {
    fontWeight:
      dropDownList.indexOf(text) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelect(props) {
  const classes = useStyles();
  const theme = useTheme();
  const {item = {}} = props;

  return (
    <Select
      labelId="demo-mutiple-chip-label"
      id={item?.id || item?.label}
      multiple
      fullWidth
      variant='outlined'
      // value={personName}
      // onChange={handleChange}
      value={props.value ?? []}
      onChange={(event) => {
        props.onChange(event.target.value, item.id || item.label)
      }}
      // input={<Input id="select-multiple-chip" className='light-border' />}
      renderValue={(selected) => (
        <div className={classes.chips}>
          {selected.map((value) => {
            return (
              <Chip key={value} label={value.text}/>
            )
          })}
        </div>
      )}
      MenuProps={MenuProps}
    >
      {(props.dropdownList || []).map((item, index) => (
        <MenuItem key={item + index} value={item} style={getStyles(item, props.dropdownList, theme)}>
          <Checkbox checked={props?.value ? props.value.indexOf(item) > -1 : false}/>
          <ListItemText primary={item?.text} className='text-capitalize'/>
        </MenuItem>
      ))}
    </Select>
  );
}
